import React from "react";
import Column from "@amzn/meridian/esm/components/column";
import { AIMS_STATUS, ROLES } from "../../constants";
import TranscribeBox from "./TranscribeBox";
import TranscriptNotAvailable from "./TranscribeNotAvailable";

/**
 * Transcript component handles all transcript-related functionality
 * without showing the tab navigation (AimsMasthead).
 */
const Transcript = ({
  aimsStatus,
  role,
  meetingId,
  meetingUuid,
  alias,
  appContext,
  initialIsRtmsStartedByOther,
  initialRtmsRequesterName,
  transcriptionState,
  setTranscriptionState,
  isRestarting,
  setIsRestarting,
  isAutostarting,
  setIsAutostarting,
  autoStartMode
}) => {
  return (
    <Column spacing="none">
      {/* Transcript available for organizer/alternative host */}
      {aimsStatus === AIMS_STATUS.TRANSCRIPT_AVAILABLE && (role === ROLES.ORGANIZER || role === ROLES.ALTERNATIVE_HOST) ? (
        <TranscribeBox
          meetingId={meetingId}
          meetingUuid={meetingUuid}
          role={role}
          alias={alias}
          appContext={appContext}
          initialIsRtmsStartedByOther={initialIsRtmsStartedByOther}
          initialRtmsRequesterName={initialRtmsRequesterName}
          transcriptionState={transcriptionState}
          setTranscriptionState={setTranscriptionState}
          isRestarting={isRestarting}
          setIsRestarting={setIsRestarting}
          isAutostarting={isAutostarting}
          setIsAutostarting={setIsAutostarting}
          autoStartMode={autoStartMode}
        />
      ) : 
        <TranscriptNotAvailable />
      }
    </Column>
  );
};

export default Transcript;
